/**
 * Header names of the access tokens of the emergency links (Taiga #1898, BSI TR-03161-2 O.Source_11).
 *
 * The token travels in a header, not in the address of the call: an address ends up in access logs, in proxies and in
 * the browser history. The value is sent as it comes out of the link, not encoded for an address.
 */
export const EMERGENCY_AGENT_TOKEN_HEADER = 'X-Emergency-Agent-Token';
export const EMERGENCY_PROFILE_TOKEN_HEADER = 'X-Emergency-Profile-Token';
